<template lang="pug">
button-base.button-direction(:class='classObject', @click='clickEvent')
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

type Direction = 'left' | 'right'

/**
 * 矢印ボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonDirection extends Vue {
  @Prop({ default: 'left' })
  direction!: Direction

  private get classObject(): { [key: string]: boolean } {
    return {
      'direction-left': this.direction == 'left',
      'direction-right': this.direction == 'right',
    }
  }

  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-direction
  width 50px
  height var(--input-height-default)
  background-color var(--color-input-direction__background)
  border 2px solid var(--color-input-direction__border)
  border-radius 10px

  &.direction-left::after
    position absolute
    top 0
    bottom 0
    left 0
    right 13px
    margin auto
    content ""
    width 15px
    height 15px
    border 10px solid transparent
    border-right 15px solid var(--color-input-direction__border)

  &.direction-right::after
    position absolute
    top 0
    bottom 0
    left 13px
    right 0
    margin auto
    content ""
    width 15px
    height 15px
    border 10px solid transparent
    border-left 15px solid var(--color-input-direction__border)
</style>
